import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE_URL from "../api";
import SEO from "../components/SEO";
import "../styles/AdmissionForms.css";

const AdmissionForms = () => {
  const [forms, setForms] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/admission-forms`)
      .then((res) => res.json())
      .then((data) => setForms(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error(err);
        setForms([]);
      });
  }, []);

  return (

    <><SEO
      title="Latest Admission Details 2026"
      description="Download Latest Government Exam Admit Cards."
      keywords="Admissions Entrance Counselling"
      url="https://sarkaricareerinfo.com/admission-forms" />
      
      <div className="page-container">

        <h2 className="page-title">
          Latest Admission Forms
        </h2>

        <div className="table-wrapper">
          <table className="admission-table">

            <thead>
              <tr>
                <th>Course - Institution</th>
                <th>Admission Type</th>
                <th>Last Date</th>
                <th>More Details</th>
              </tr>
            </thead>

            <tbody>
              {forms.map((form, index) => (
                <tr key={index}>

                  <td>
                    <div className="course-name">
                      {form.course_name}-{form.institution_name}
                    </div>
                  </td>

                  <td>
                    {form.admission_type}
                  </td>

                  <td>
                    {form.application_last_date}
                  </td>

                  {/* <td>
              <Link
                to={`/admission-forms/${index}`}
                state={{ json: form.json_data }}
                className="details-link"
              >
                View Details
              </Link>
            </td> */}

                  <td data-label="Action" className="col-action">
                    <a
                      href={form.notification_pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-details"
                    >
                      View Details
                    </a>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>
        </div>

      </div></>
  );
};

export default AdmissionForms;